/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TaskTriggersEnum = 'OPERATOR' | 'TENANT';

export const TaskTriggersEnum = {

    OPERATOR: 'OPERATOR' as TaskTriggersEnum,

    TENANT: 'TENANT' as TaskTriggersEnum
};

